module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qpelv2-ee01abd3e38eb56d55ea1b746984057a.jpg";